export default __webpack_public_path__ + "static/media/tick.inline.bd0b7049.svg";